import React from 'react';
import {View, TouchableOpacity, StyleSheet} from 'react-native';
import {Screens} from '../../../shared/routing';
import {IStateProps} from './model';
import {NameInfo} from './components/nameInfo';
import {USCInfo} from './components/uscInfo';
import {images} from '../../../assets/icons';
import {Forms} from '../../../shared/models/forms';
import {IChangePasswordForm} from '../common/changePassword/model';
import {initialize} from 'redux-form';

import {useAppDispatch} from '../../../redux';
import {Text} from '../../../shared/components/text';
import Screen from '../../../shared/components/screen';
import {CustomScrollView} from '../../../shared/components/scrollView';
import {UscType} from '../../../shared/models/profile/uscType';
import {GetMenuItemStyles, GetStyles} from './style';
import {CardStatus} from '../../../types/enums/cardStatus';

const MenuItem = (props: {
  onPressMenuItem: (screem: Screens) => void;
  screen: Screens;
  title: string;
  testID: string;
}) => {
  const styles = GetMenuItemStyles();
  const {onPressMenuItem, screen, title, testID} = props;
  return (
    <TouchableOpacity
      testID={testID || `profile-mobile-menu-item-${screen}-link-id`}
      style={styles.menuElement}
      onPress={() => onPressMenuItem(screen)}
      accessibilityRole='link'>
      <Text type='h6Light' style={styles.title}>
        {title}
      </Text>
      <View style={styles.arrow}>
        <images.Right width={24} height={24} color={StyleSheet.flatten(styles.arrowColor).color} />
      </View>
    </TouchableOpacity>
  );
};

export default ({onPressMenuItem, holderProfile, onExitClick, profileSettings}: IStateProps) => {
  const dispatch = useAppDispatch();
  const styles = GetStyles();
  if (!holderProfile || !profileSettings) {
    return (
      <Screen>
        <CustomScrollView>
          <View testID='profile-mobile-exit-container-id' style={styles.container}>
            <TouchableOpacity
              testID='profile-mobile-exit-id'
              style={[styles.row, styles.smallButtonContainer, styles.fallbackContainer]}
              onPress={onExitClick}>
              <images.SignOut height={24} width={24} color={StyleSheet.flatten(styles.iconColor).color} />
              <Text testID='profile-mobile-exit-text-id' style={[styles.action, styles.actionExit]}>
                Выйти
              </Text>
            </TouchableOpacity>
          </View>
        </CustomScrollView>
      </Screen>
    );
  }

  const {dateIssue, campusParticipant, uscIsBlocked, cardStatusId, hasPassword, uscType} = holderProfile;
  const isFinancialCard = uscType === UscType.Financial;
  const isActiveCard = cardStatusId === CardStatus.Active;

  const onPressChangePassword = () => {
    const initialFormData: IChangePasswordForm = {
      confirmPassword: '',
      newPassword: '',
      oldPassword: '',
    };

    dispatch(initialize(Forms.changePassword, initialFormData));
    onPressMenuItem(Screens.ProfileChangePassword);
  };

  return (
    <Screen>
      <CustomScrollView testID='scroll-profile-id'>
        <View testID='profile-id' style={styles.container}>
          <NameInfo testID='profile-name-id' name={holderProfile.displayName || ''} />
          {!(uscIsBlocked || cardStatusId === CardStatus.Blocked) && (
            <USCInfo dateUntil={dateIssue} isCampusParticipant={campusParticipant} />
          )}
          <View testID='profile-menu-id' style={styles.menuContainer}>
            <MenuItem
              testID='profile-menu-item-common-id'
              title='Общая информация'
              onPressMenuItem={onPressMenuItem}
              screen={Screens.ProfileBaseInfo}
            />
            <MenuItem
              testID='profile-menu-item-requests-id'
              title='Мои заявления'
              onPressMenuItem={onPressMenuItem}
              screen={Screens.ProfileApplications}
            />
            <MenuItem
              testID='profile-menu-item-documents-id'
              title='Мои документы'
              onPressMenuItem={onPressMenuItem}
              screen={Screens.ProfileUserDocuments}
            />
            <MenuItem
              testID='profile-menu-item-contacts-id'
              title='Контактные данные'
              onPressMenuItem={onPressMenuItem}
              screen={Screens.ProfileUserContacts}
            />
            <MenuItem
              testID='profile-menu-item-notifcation-settings-id'
              title='Настройка уведомлений'
              onPressMenuItem={onPressMenuItem}
              screen={Screens.ProfileNotificationSettings}
            />
            <MenuItem
              testID='profile-menu-item-linked-accounts-id'
              title='Связанные аккаунты'
              onPressMenuItem={onPressMenuItem}
              screen={Screens.ProfileLinkedAccounts}
            />
            {!(isFinancialCard && isActiveCard) && (
              <MenuItem
                testID='profile-menu-item-security-id'
                title='Безопасность'
                onPressMenuItem={onPressMenuItem}
                screen={Screens.ProfileSafety}
              />
            )}
            <View testID='profile-menui-item-password-rule-id' style={styles.column}>
              <TouchableOpacity
                testID='profile-mobile-change-password-id'
                style={styles.smallButtonContainer}
                onPress={() =>
                  holderProfile.hasPassword ? onPressChangePassword() : onPressMenuItem(Screens.ProfileCreatePassword)
                }>
                <Text testID='profile-mobile-change-create-password-text-id' style={styles.action}>
                  {hasPassword ? 'Сменить пароль' : 'Создать пароль'}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                testID='profile-mobile-exit-second-id'
                style={[styles.row, styles.smallButtonContainer]}
                onPress={onExitClick}>
                <images.SignOut height={24} width={24} color={StyleSheet.flatten(styles.iconColor).color} />
                <Text testID='profile-mobile-exit-second-text-id' style={[styles.action, styles.actionExit]}>
                  Выйти
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
